"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isJSON = void 0;
const assertString_1 = require("./util/assertString");
const merge_1 = require("./util/merge");
const default_json_options = {
    allow_primitives: false,
};
function isJSON(str, options = {}) {
    (0, assertString_1.assertString)(str);
    try {
        options = (0, merge_1.merge)(options, default_json_options);
        let primitives = [];
        if (options.allow_primitives) {
            primitives = [null, false, true];
        }
        const obj = JSON.parse(str);
        return primitives.includes(obj) || (!!obj && typeof obj === 'object');
    }
    catch (e) { /* ignore */
    }
    return false;
}
exports.isJSON = isJSON;
